import gql from "graphql-tag";

export const GET_TEMPO_ORDERS = gql`
 query tempoOrders($filterDate: date!){
  tempoOrders(where: {date: {_eq: $filterDate}}) {
    id
    tempoOrderCode
    contractorCode
    contractorId
    contractor{id name}
    date
    driverId
    driverDetail{id name}
    endReading
    startReading
    city
    City{id shortCode}
    tempoId
    tempo{id name platNo}
    orderDetailsArr{
    id
    lrObject
    order{
        id
        orderNumber
        clientobject
        pickuppartyobject
        droppingpartyobject
        materials
        note
          }
      }
    }
 }
`
export const GET_TEMPO_ORDER_BY_ID = gql`
 query tempoOrderDetail($tempoOrderId: uuid!){
  tempoOrderDetail:tempoOrders(where: {id: {_eq: $tempoOrderId}}) {
    id
    tempoOrderCode
    contractorCode
    contractor{id name mobile}
    date
    city
    driverDetail{id name mobile}
    endReading
    startReading
    tempo{id name platNo capacity}
   }
 }
`
export const GET_SINGLE_TEMPO_ORDER = gql`
 query tempoOrders($tempoOrderId: uuid!){
  singleTempoOrders: tempoOrders(where: {id: {_eq: $tempoOrderId}}) {
    id
    driverDetail{id name}
    tempo{id name platNo}
    }
 }
`
// tempoOrders(where: {_and: {date: {_eq: $filterDate}, city: {_eq: $filterCity}}}) {
export const GET_TEMPO_ORDERS_BY_DATE_AND_CITY = gql`
 query tempoOrders($filterDate: date!){
  tempoOrders(where: {_and: [{date: {_eq: $filterDate}},{endReading: {_eq: ""}}]}) {
    id
    tempo{ id name platNo type Contractor{id name type} }
    driverDetail{id name}
    orderDetailsArr{
      id
      order{
        id
        orderNumber
        pickuppartyobject
        droppingpartyobject
          }
       }
    }
 }
`
export const GET_OCCUPIED_TEMPOS_AND_DRIVERS = gql`
 query tempoOrders($todayDate: date!){
  occupiedTempoAndDriverIds: tempoOrders(where: {date: {_eq: $todayDate}}) {
    id
    tempoId
    driverId
    }
 }
`
export const GET_LAST_TEMPO_ORDER_CODE = gql`
query tempoOrders($todayDate: date!){
  lastTempoOrder: tempoOrders(where: {date: {_eq: $todayDate}}, order_by: {createdAt: desc}, limit: 1) {
      id
      tempoOrderCode
  }
}
`
